// import zIndex from "@mui/material/styles/zIndex";
import { bgColors } from "../utils/bgColor";
export  const FabButtonStyle =  {
    backgroundColor: bgColors.sidpanel_grey,
    color: bgColors.grey_300,
    opacity:0.8
  
  }

export  const iconStyle = {
    backgroundColor: bgColors.sidpanel_grey,
    color: bgColors.grey_300,
    maxHeight: '30px',
    maxWidth: '30px'
  }

export  const listItemStyle = {
    backgroundColor: bgColors.sidpanel_grey,
    color: bgColors.grey_300,
    opacity:.9

}

export const boxStyle = {
    backgroundColor: bgColors.sidpanel_grey,
    color: bgColors.grey_300,
    opacity:.9,
    zIndex:3
}

export const dividerStyle = {
    backgroundColor: bgColors.grey_700,
    opacity:0.9,
}


export const stylemaster = {
  root:{
  padding: '0rem',
  color: bgColors.green_700
  // backgroundColor: bgColors.sidebar_grey,
  },
  appbartyle:{
    padding: '0rem',
    color: bgColors.grey_900,
    background:bgColors.green_300,
    maxHeight:'45px'
    },
    paperstyle:{
    height: '200px',
    color: bgColors.default_backgroun_grey,

  },
    iconStyle : {
    fontSize:'large',
    padding: '0.1rem',
    color: bgColors.font_blue,
    // background: bgColors.green_300
  },
  title:{
    padding: '0.25rem'
  },
  Typography_body:{
    marginLeft:'2rem', 
    fontSize: 14, 
    fontFamily:'roboto'
  },
  Typography_label:{
      marginLeft:'0rem', 
      fontSize: 14, 
      fontFamily:'roboto',
      fontWeight:'bold'

  },

  Typography_title:{
    marginLeft:'0rem  ', 
    fontSize: 18, 
    fontFamily:'roboto'
  },
  Typography_header:{
    marginLeft:'0rem  ', 
    fontSize: 24, 
    fontFamily:'roboto'
  },

  GridContainerReportTitle: {
    display:'flex',
    direction:'row',
    justifyContent:'flex-start'
  }


}

